import React from "react";
import Header from "./Header";
import Home from "./Home";

const HomeR = () =>{
    return(
    <>
        <Header></Header>
        <Home></Home>
    </>
    );
};

export default HomeR;
